import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchTreatments} from '../../../actions/addTreatments';
import { getCurrentPetShop } from "../../../actions/petShop";
import { fetchMedicalRecords } from '../../../actions/medicalRecords';
import { fetchContracts } from '../../../actions/contracts'
import { NavLink } from 'react-router-dom';
import ViewTreatment from '../../treatments/treatments/viewTreatment';
import moment from 'moment';
import _ from 'lodash';
import { forceInputUppercase } from "../../../utils/helper";
import { NotificationManager } from 'react-notifications';
import { sendEmailCustomer,fetchVerifyEmail} from '../../../actions/customers';
import Select from "react-select";
const $ = window.$;
const intialState = {
    trmntsOnGoing:[],
    trmntsPending:[],
    mRecords:[],
    allmRecords:[],
    contracts:[],
    treatId:'',
    petId:null,
    email:"",    
    typeMail:"", 
    vlidateFlag:false,
    verifyEmail:[],
    verifyEmailId:"",
    successEmail:false,
}

class CashierDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = intialState;
    }
    viewTreatment(tId) {
        this.setState({treatId: tId})
        $('#view_treatment').modal('show');
    }
    changeVal = event => {
        forceInputUppercase(event);    
        let value = event.target.value;
    
        if (event.target.name === 'petId'){
             value = value.split(" ").join("");
        }
    
        this.setState({
          ...this.state,
          [event.target.name]: value
        });
      };
    changeEmailType = selected => {     
        if (selected) {
          this.setState({ verifyEmailId: selected.value });
        }
      };  
    sendEmail(){
      let mailArry = [];    
      mailArry = this.state.email ? this.state.email.split(','):[];
      let validEmail = this.validateEmailList(mailArry);
      if(validEmail && mailArry && mailArry.length > 0 && this.state.petId ) {   
      let mailObject ={
          petId: this.state.petId,
          from: this.state.verifyEmailId,
          email: mailArry,
          base_url: process.env.REACT_APP_API_ENDPOINT
      };         
      this.props.sendEmailCustomer(mailObject);
    }
    else{        
        if(!validEmail){
            NotificationManager.error("Please enter a valid email address.");    
            }
            else{  
            NotificationManager.error("Please check input details again.");
            this.setState({vlidateFlag:true});
            }
    }    
    }; 
    validateEmailList(emails){    
        var valid = true;
        var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        for (var i = 0; i < emails.length; i++) {
            if( emails[i] === "" || !regex.test(emails[i].replace(/\s/g, ""))){
                valid = false;
            }
        }
        return valid;
    } 
    componentDidMount() {
        this.props.fetchTreatments(); 
        this.props.fetchMedicalRecords();
        this.props.fetchContracts();
        this.props.fetchVerifyEmail();
    }
    componentWillReceiveProps = (nextProps) => {
        // if(nextProps.treatmentError||nextProps.mRecordsError||nextProps.mRecordCountError || nextProps.contractsError){
        //     NotificationManager.error('Something went wrong!')
        // }
        
        if ( this.props.treatments !== nextProps.treatments) {
            let trtPending = nextProps.treatments.filter(m => m.status==='Pending').sort((a,b)=>{return a.daysLeft - b.daysLeft}).slice(0,5);
            let trtInprogress = nextProps.treatments.filter(m => m.status==='In progress').sort((a,b)=>{return a.daysLeft - b.daysLeft}).slice(0,5);
            this.setState({ trmntsPending: trtPending, trmntsOnGoing: trtInprogress });
        }
        if(nextProps.mRecords && nextProps.mRecords.medicalRecords && nextProps.mRecords.medicalRecords.length > 0 && this.props.mRecords.medicalRecords !== nextProps.mRecords.medicalRecords){
            let allMRecords = nextProps.mRecords.medicalRecords;
            let mRecords = allMRecords.sort((a,b)=>{return moment().diff( a.createdAt, 'days') - moment().diff( b.createdAt, 'days')}).slice(0,5);
            this.setState({ mRecords: mRecords, allmRecords: allMRecords}); 
        }
        if(nextProps.contracts && nextProps.contracts.contractRecords && nextProps.contracts.contractRecords.length > 0 && this.props.contracts.contractRecords !== nextProps.contracts.contractRecords){
            let allContract = nextProps.contracts.contractRecords;
            let cts = allContract.sort((a,b)=>{return moment().diff( a.createdAt, 'days') - moment().diff( b.createdAt, 'days')}).slice(0,5);
            this.setState({ contracts: cts}); 
        }
        if (this.props.customerEmail !== nextProps.customerEmail) {  
            NotificationManager.success(nextProps.customerEmail.message);
            this.setState({ petId:"",email:"",verifyEmailId:"" });        
            
        }  
        if (this.props.customerEmailErr !== nextProps.customerEmailErr) { 
             NotificationManager.error("Medical record not found");          
        } 
        if (
            nextProps.verifyEmailList &&
            this.props.verifyEmailList !== nextProps.verifyEmailList &&
            nextProps.verifyEmailList.length > 0
          ) {
            let options = [{ label: "Select Email", value: null }];
            nextProps.verifyEmailList.map(p => {
              options.push({ label: p.email, value: p.email });
            });
            this.setState({ verifyEmail: options });
            if (nextProps.verifyEmailList.length > 0) {
              this.setState({ verifyEmailId: null });
            }
          }
    }

    navigationMR(y){    
        let data = this.state.allmRecords;    
        let index = _.findIndex(data, {id: y.id});    
        let previndex = (index == 0) ? null : (index - 1);
        let nextindex = index + 1;    
        let prevEle = nextindex != null ? data[nextindex] ? data[nextindex].id : null : null;
        let nextEle = previndex != null ? data[previndex] ? data[previndex].id : -1 : -1; 
        let path = `/medical-records/${y.id}/${prevEle}/${nextEle}`;
        this.props.history.push(path);
    
        }

    render() {
        const {trmntsOnGoing, trmntsPending, treatId, contracts, mRecords, typeMail, verifyEmail, verifyEmailId, petId, email} = this.state;
        const { petShop } = this.props;
        return (
            <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
                <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
                    <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
                        <div className="m-grid__item m-grid__item--fluid m-wrapper">
                            <div className="row">
                                <div className="col-xl-4">
                                    <div className="m-portlet m-portlet--head-overlay m-portlet--full-height   m-portlet--rounded-force">
                                        <div className="m-portlet__head m-portlet__head--fit">
                                            <div className="m-portlet__head-caption">
                                                <div className="m-portlet__head-title">
                                                    <h3 className="m-portlet__head-text m--font-light">
                                                        Treatments
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="m-portlet__body">
                                            <div className="m-widget28">
                                                { petShop.cashier_dashboard_banner_path ?
                                                <div className="m-widget28__pic m-portlet-fit--sides">
                                                <img 
                                                  src={ petShop.cashier_dashboard_banner_path
                                                  ? process.env.REACT_APP_S3_PATH +
                                                  "/" + petShop.cashier_dashboard_banner_path: ""} alt="" /></div>
                                                :<div className="m-widget28__pic m-portlet-fit--sides"><img src="assets/app/media/img/pets/pupBg.jpg" alt="" /></div>
                                                }
                                                <div className="m-widget28__container">
                                                    <ul className="m-widget28__nav-items nav nav-pills nav-fill" role="tablist">
                                                        <li className="m-widget28__nav-item nav-item">
                                                            <a className="nav-link active show" data-toggle="pill" href="#menu11">
                                                                <span>
                                                                    <i className="fas fa-syringe" style={{ paddingBottom: '2rem', paddingTop: '1.4rem' }}></i>
                                                                </span>
                                                                <span>On going Treatments</span>
                                                            </a>
                                                        </li>
                                                        {/* <li className="m-widget28__nav-item nav-item">
                                                            <a className="nav-link" data-toggle="pill" href="#menu21">
                                                                <span>
                                                                    <i className="fa flaticon-file-1"></i>
                                                                </span>
                                                                <span>IMT Invoice</span>
                                                            </a>
                                                        </li> */}
                                                        <li className="m-widget28__nav-item nav-item">
                                                            <a className="nav-link" data-toggle="pill" href="#menu31">
                                                                <span>
                                                                    <i className="fas fa-syringe" style={{ paddingBottom: '2rem', paddingTop: '1.4rem' }}></i>
                                                                </span>
                                                                <span>Pending Treatments</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <div className="m-widget28__tab tab-content">
                                                        <div id="menu11" className="m-widget28__tab-container tab-pane active show">
                                                            <div className="m-widget28__tab-items">
                                                                <ul className="list-unstyled mb-0 list-widget">
                                                                    {trmntsOnGoing.length > 0 ? trmntsOnGoing.map((t, i) => (
                                                                        <a href="#" onClick={(e) => { e.preventDefault() }}>
                                                                            <li key={i} onClick={() => this.viewTreatment(t.id)}>
                                                                                <div className="m-widget28__tab-item" >
                                                                                    <div className="media mb-4">
                                                                                        <img className="mr-3 rounded-circle m-width-50" src={process.env.REACT_APP_S3_PATH + '/' + t.avatar_path + '/' + t.avatar_file_name} alt=" " />
                                                                                        <div className="media-body list-widget-border">
                                                                                            <div className="float-left">
                                                                                                <h6 className="text-muted "><strong>Breed: </strong>{t.breed}</h6>

                                                                                                <h6 className="text-muted "><strong>Treatment: </strong>{t.calculation_name}</h6>
                                                                                                <span className="text-muted"><strong>Dosage: </strong> {t.dosage}</span>
                                                                                            </div>
                                                                                            <div className='float-right'>
                                                                                                <span className="m-badge m-badge--info px-2">Pet Id: <strong>{t.pet_id}</strong></span>
                                                                                                <p className="text-muted">{t.daysLeft ? t.daysLeft : 0}<small> days remaining</small></p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                            <hr />
                                                                        </a>
                                                                    )) : <span>No any ongoing treatments.</span>}

                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div id="menu31" className="m-widget28__tab-container tab-pane fade">
                                                            <div className="m-widget28__tab-items">
                                                                <ul className="list-unstyled mb-0 list-widget">
                                                                    {trmntsPending.length > 0 ? trmntsPending.map((t, i) => (
                                                                        <a href="#" onClick={(e) => { e.preventDefault() }}>
                                                                            <li key={i} onClick={() => this.viewTreatment(t.id)}>
                                                                                <div className="m-widget28__tab-item" >
                                                                                    <div className="media mb-4">
                                                                                        <img className="mr-3 rounded-circle m-width-50" src={process.env.REACT_APP_S3_PATH + '/' + t.avatar_path + '/' + t.avatar_file_name} alt=" " />
                                                                                        <div className="media-body list-widget-border">
                                                                                            <div className="float-left">
                                                                                                <h6 className="text-muted "><strong>Breed: </strong>{t.breed}</h6>
                                                                                                <h6 className="text-muted "><strong>Treatment: </strong>{t.calculation_name}</h6>
                                                                                                <span className="text-muted"><strong>Dosage: </strong> {t.dosage}</span>
                                                                                            </div>
                                                                                            <div className='float-right'>
                                                                                                <span className="m-badge m-badge--info px-2">Pet Id: <strong>{t.pet_id}</strong></span>
                                                                                                <p className="text-muted">{t.daysLeft ? t.daysLeft : 0}<small> days remaining</small></p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </a>
                                                                    )) : <span>No any pending treatments.</span>}
                                                                    <hr />
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="m-portlet m-portlet--full-height ">
                                        <div className="m-portlet__head">
                                            <div className="m-portlet__head-caption">
                                                <div className="m-portlet__head-title">
                                                    <h3 className="m-portlet__head-text">
                                                        Contracts
                                                        </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="m-portlet__body">
                                            <div className="m-widget3">
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        {contracts.map((c,i)=>(                                  
                                                        <NavLink key={i} to={`/contracts/${c.id}`} title="Edit" className='nav-link nav-link_deco'>
                                                        <div className="m-widget3__item"  >
                                                            <div className="m-widget3__header" style={{width:'100%'}}>
                                                                <div className="row">
                                                                    <div className="col-xl-2 col-sm-2 px-0" style={{width:'auto'}}>
                                                                        <div className="m-widget3__user-img">
                                                                            <img className="m-widget3__img ml-1" src={process.env.REACT_APP_S3_PATH + '/' + c.avatar_path + '/' + c.avatar_file_name} alt=""/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xl-4 col-sm-3 px-0" style={{width:'auto'}}>
                                                                        
                                                                        <div className="m-widget3__info pb-2">
                                                                            
                                                                            <span className="m-badge m-badge--info px-2"> Pet Id: <strong>{c.pet_id}</strong></span>
                                                                            <br/>
                                                                            <span className="m-widget3__username">
                                                                                {c.breed_type} 
                                                                            </span>
                                                                            <br/>
                                                                            <span className="m-widget3__time">
                                                                            {moment(c.date).format('YYYY-MM-DD')}
                                                                            </span>                                                                        
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xl-6 col-sm-7 px-0" style={{width:'auto'}}>
                                                                        <div className="m-widget3__info pb-2 " style={{float:'right'}}>
                                                                            <h5 className="m--font-danger">  ${c.total}</h5>
                                                                            <span className="m-widget3__username">
                                                                                {c.cus_firstname} {c.cus_lastname}
                                                                            </span>
                                                                            <br/>
                                                                            <span className="m-widget3__time">
                                                                                {c.cus_primary}
                                                                            </span>                                                                        
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                        </NavLink>
                                                        ))}                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="m-portlet m-portlet--full-height ">
                                        <div className="m-portlet__head">
                                            <div className="m-portlet__head-caption">
                                                <div className="m-portlet__head-title">
                                                    <h3 className="m-portlet__head-text">
                                                        Recent Puppy Records
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="m-portlet__body">
                                            <div className="m-widget3">
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                    {mRecords.map((m,i)=>(                                  
                                                        <div className="m-widget3__item"  >
                                                            <div className="m-widget3__header">
                                                                <div className="m-widget3__user-img">
                                                                    <img className="m-widget3__img" src={process.env.REACT_APP_S3_PATH + '/' + m.avatar_path + '/' + m.avatar_file_name} alt=""/>
                                                                </div>
                                                                <div className="m-widget3__info pb-2">
                                                                    {/* <span className="m-widget3__username">
                                                                        Melania Trump
                                                                    </span> */}
                                                                    <a style={{cursor: "pointer"}} onClick={e=>{this.navigationMR(m)}}>
                                                                    <span className="m-badge m-badge--info px-2"> Pet Id:<strong>{m.pet_id}</strong></span>
                                                                     </a>
                                                                    <br/>
                                                                    <p className="m-widget3__text mb-0">
                                                                        <strong>Breed:</strong> {m.Breed.breed_type}
                                                                    </p>
                                                                    <span className="m-widget3__time">
                                                                        {moment().diff( m.createdAt, 'days')} days ago.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>                                                    
                                                    ))}
                                                                                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                        <div className="col-xl-12" style={{justifyContent:"center"}}>
                            <div className="m-portlet">
                                <div className="m-portlet__body  m-portlet__body--no-padding">
                                    <div className="row m-row--no-padding m-row--col-separator-xl">
                                        <div className="col-xl-12 col-md-12">                                            
                                            <div className="m-portlet__head" style={{borderBottom:0}}>
                                                <div className="m-portlet__head-caption">
                                                    <div className="m-portlet__head-title">
                                                        <div>
                                                        <h3 className="m-portlet__head-text">
                                                         Customer Inquiries for Puppy Records
                                                        </h3>
                                                        </div>
                                                     </div>                                                                                                  
                                                </div>                                        
                                            </div>                                       
                                            <div className="m-portlet__body">
                                                <div className="m-widget3">                                              
                                                    <div className="form-group m-form__group row">                                                      
                                               
                                                        <label className="col-lg-1 col-sm-12 col-form-label cust-inq">
                                                        {" "}
                                                        Pet Id:
                                                        </label>
                                                                                                
                                                    <div className="col-lg-2 cust-inq-pad-left">
                                                    <input
                                                        type="text"
                                                        name="petId"
                                                        onChange={this.changeVal}
                                                        className="form-control m-input"
                                                        placeholder="Enter Pet Id"
                                                        value={petId}
                                                    
                                                    />                                             
                                                   </div>                                                 
                                                   <label className="col-lg-1 col-sm-12 col-form-label cust-inq">
                                                    {" "}
                                                    From:
                                                    </label>
                                                    <div className="col-lg-2 cust-inq-pad-left">
                                                    <Select
                                                        options={verifyEmail}
                                                        value={verifyEmailId}
                                                        name="typeMail"
                                                        onChange={this.changeEmailType}
                                                        placeholder="Select Sending Email"
                                                   />                                           
                                                   </div> 
                                                    <label className="col-lg-1 col-sm-12 col-form-label cust-inq">
                                                    {" "}
                                                    To:
                                                    </label>
                                                    <div className="col-lg-3 cust-inq-pad-left">
                                                    <input
                                                        type="text"
                                                        name="email"
                                                        onChange={this.changeVal}
                                                        className="form-control m-input"
                                                        placeholder="Enter Email Address"
                                                        value={email}                                                    
                                                    />                                           
                                                    </div>    
                                                    <div className="col-lg-2 cust-inq-pad-left">
                                                    <button
                                                        type="button"                                                    
                                                        className="btn btn-primary m-btn--pill" 
                                                        style={{ float: "right" }}  
                                                        onClick={()=>this.sendEmail()}                                                      
                                                    >
                                                        <span>
                                                         <i className="la la-check"></i>
                                                         &nbsp;&nbsp;
                                                          <span>Submit</span>
                                                        </span>
                                                    </button>                                           
                                                   </div>                                                                                                                                                     
                                                </div>                                         
                                        
                                                </div>
                                            </div>                                                    
                               
                                        </div>                             
                                        
                                    </div>
                                </div>
                            </div>
                    
                        </div>
                    </div>  
                        </div>
                        <ViewTreatment treatmentId={treatId} />
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  treatments:state.addFormulaReducer.treatment,
  mRecords:state.medicalRecordsReducer.mRecords,
  contracts:state.contractsReducer.contracts,

  treatmentError:state.addFormulaReducer.treatmentError,
  mRecordsError:state.medicalRecordsReducer.mRecordsError,
  contractsError:state.contractsReducer.contractsError,
  customerEmail:state.customersReducer.email,
  customerEmailErr:state.customersReducer.emailSendError,
  verifyEmailList: state.customersReducer.emailList,
  
  petShop: state.petShopReducer.currentPetshop,  

});
const mapDispatchToProps = dispatch => ({
    fetchTreatments: () => {
        dispatch(fetchTreatments());
    },
    fetchMedicalRecords: () => {
        dispatch(fetchMedicalRecords());
    },
    fetchContracts:() => {
        dispatch(fetchContracts());
    },
    sendEmailCustomer:(data)=>{
        dispatch(sendEmailCustomer(data));
    },
    fetchVerifyEmail:()=>{
        dispatch(fetchVerifyEmail());
    },
    getCurrentPetShop: t => {
        dispatch(getCurrentPetShop(t));
    }

    
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CashierDashboard));
